
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.59 10.005H8.185L5.861 6.721l-2.44 3.284H0l4.244-5.336L.817 0h3.455l1.604 2.538L7.586 0h3.516L7.509 4.669z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    